<template lang="html">
  <div class="shopify-create-store">
    <Guide
      width="small"
      :content="content"
      contentHeading="Create a Google Analytics Account"
      :closeLink="closeLink"
      :nextLink="nextLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'AnalyticsCreateAnalyticsAccount',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'analytics-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'analytics-save-id',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p><strong>All Google needs is some basic info about what site you'd like to monitor.</strong></p>
        <p>You'll get a tracking code to paste into our platform so Google knows when your site is visited.</p>
        <hr>
        <p>Go to <a href="https://analytics.google.com/analytics/web/" target="_blank">Google Analytics</a> and click <strong>Sign up</strong> to create your account.</p>
        <p>Fill in your <strong>Account Name</strong> and <strong>Propery Name</strong> with the name of your website, as well as your <strong>Industry</strong>, <strong>Business size</strong> and the additional checkboxes.</p>
        <p>You'll then need to accept the terms and conditions and continue.</p>
        <p>After that, you'll be taken to a page that allows you to <strong>set up a data stream</strong> to start collecting data. Click on <strong>Web</strong>.</p>
        <p>Enter your <strong>Website URL</strong> and <strong>Stream name</strong> (this can be your website name).</p>
      `
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
